import React from "react";
import { 
  TickerWrapper,
  TickerInner,
  TickerContainer,
  WhiteHeading,
  YellowHeading,
  TickerSeparator,
  BoldParagraph,
  RegularParagraph,
  FooterParagraph
} from "./MintTicker.styled";

export default function VerticalTicker () {
  return (
    <TickerContainer>
      <video style={{"width": "100%"}} src="/assets/control_room.webm" muted autoPlay={true} loop/>
      {/*<TickerWrapper>
        <TickerInner>
          <WhiteHeading>$ACTION FIGURES ARE</WhiteHeading>
          <YellowHeading>MULTITUDE CONTAINERS</YellowHeading>
          <WhiteHeading>THAT WORK EVERYWHERE</WhiteHeading>
          <TickerSeparator />
          <BoldParagraph>
            $ACTION FIGURES are solarpunk defenders of our planet.
            The mutant offspring of a new financial system colliding with
            emergent subcultures, spawned during a technological paradigm shift. 
          </BoldParagraph>
          <TickerSeparator />
          <BoldParagraph>
            They're not just tokens; they're cosmic messengers, 
            ushering in a new era of human interaction and organization.
          </BoldParagraph>
          <TickerSeparator/>
          <RegularParagraph>
            Using the <b>$ACTION AI-powered gaming substrate</b>,
            built on the AO Supercomputer and Arweave,  
            you can upgrade $ACTION Figures, forge them into unique warriors, 
            and equip them with $ACTION ITEMS to further their mission.
          </RegularParagraph>
          <TickerSeparator/>
          <RegularParagraph>
            $ACTION Figures are designed to enhance the memetic landscape, 
            and enable cross-platform content generation. Constructed from 
            a variety of body types, traits and abilities, they are 
            compatible with games, socials and creator apps. 
          </RegularParagraph>
          <TickerSeparator/>
          <FooterParagraph>IT'S TIME TO LEVEL UP.</FooterParagraph>
          <TickerSeparator/>
          <FooterParagraph>IT'S TIME FOR $ACTION.</FooterParagraph>
          
        </TickerInner>
      </TickerWrapper>*/}
    </TickerContainer>
  );
}
